import { useState } from "react";
import { useLocation } from "react-router-dom";

import { t } from "../../lib/i18n";
import { resolvePageMeta } from "../../lib/pageMeta";
import { useAuth } from "../../lib/auth";
import { useLocale } from "../../lib/useLocale";
import { CompanyQRModal } from "../qr/CompanyQRModal";
import { Button } from "../ui/Button";

import { LanguageSwitcher } from "./LanguageSwitcher";

import "./layout.css";

export function Topbar({ onOpenMenu }: { onOpenMenu: () => void }) {
  useLocale();
  const { user, signOut } = useAuth();
  const [qrOpen, setQrOpen] = useState(false);
  const location = useLocation();

  const meta = resolvePageMeta(location.pathname);
  const crumbs: string[] = [t("app.title")];
  if (meta) {
    crumbs.push(t(meta.sectionKey));
    crumbs.push(t(meta.pageKey));
    if (meta.subPageKey) {
      crumbs.push(t(meta.subPageKey));
    }
    if (meta.detailKey) {
      crumbs.push(t(meta.detailKey));
    }
  }

  return (
    <header className="app-shell__topbar">
      <div className="topbar">
        <div className="topbar__leading">
          <Button
            className="mobile-nav-toggle"
            variant="ghost"
            onClick={onOpenMenu}
            aria-label={t("nav.openMenu")}
            aria-haspopup="dialog"
          >
            <span aria-hidden="true">☰</span>
          </Button>
          <nav className="topbar__crumbs" aria-label="breadcrumb">
            {crumbs.map((label, index) => {
              const isLast = index === crumbs.length - 1;
              return (
                <span key={`${label}-${index}`} className="topbar__crumb">
                  {index > 0 && (
                    <span className="topbar__crumb-sep" aria-hidden="true">
                      /
                    </span>
                  )}
                  {isLast ? <strong>{label}</strong> : <span>{label}</span>}
                </span>
              );
            })}
          </nav>
        </div>

        <div className="topbar__right">
          {user?.company && (
            <div className="topbar__company">
              <strong>{user.company.name}</strong>
              {user.company.domain && <span>· {user.company.domain}</span>}
            </div>
          )}
          {user && (
            <Button
              variant="secondary"
              size="sm"
              onClick={() => setQrOpen(true)}
              aria-label={t("qr.title")}
            >
              {t("qr.button")}
            </Button>
          )}
          <LanguageSwitcher />
          <Button variant="ghost" size="sm" onClick={() => void signOut()}>
            {t("auth.signOut")}
          </Button>
        </div>
      </div>
      <CompanyQRModal open={qrOpen} onClose={() => setQrOpen(false)} />
    </header>
  );
}
